// @flow
import type { TRound, TPLeague } from '../../../modules/types';

export const isDraftLeagueByeRound = (league: TPLeague, round: TRound) => {
	if (league && round) {
		return Boolean(league.bye_rounds) ? false : round.is_bye;
	}

	return false;
};